import store from '../store'

export default [
  {
    path: '/relatorios/tecnico',
    name: 'relatorios-tecnico-index',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getTecnicos')
      await store.commit('setRelatorio', [])
      next()
    },
    meta: {
      title: 'Relatórios de técnicos',
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/tecnico'
      )
    }
  },
  {
    path: '/relatorios/tecnico/cliente/atendido/exibir',
    name: 'relatorios-tecnico-cliente-atendido-show',
    beforeEnter: async (to, from, next) => {
      const { tecnico, inicial, final } = store.getters.variaveis
      await store.dispatch('getTecnico', {
        id: Number(tecnico)
      })
      await store.dispatch('getRelatorioTecnicoClienteAtendido', {
        tecnico: Number(tecnico),
        inicial,
        final
      })
      next()
    },
    meta: {
      title: 'Relatório de clientes atendidos',
      isIndustry: false,
      isShowSumValue: true,
      sumValueType: 'atendimentos',
      showSumValue: array =>
        array.reduce(
          (acum, item) => (acum += Number(item.visita_proporcao)),
          0
        ),
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/tecnico/filtros/atendidos'
      )
    }
  },
  {
    path: '/relatorios/tecnico/cliente/atendido/balancete-requerido/exibir',
    name: 'relatorios-tecnico-cliente-atendido-balancete-requerido-show',
    beforeEnter: async (to, from, next) => {
      const { tecnico, inicial, final } = store.getters.variaveis
      await store.dispatch('getTecnico', {
        id: Number(tecnico)
      })
      await store.dispatch('getRelatorioTecnicoClienteAtendidoBalanceteRequerido', {
        tecnico: Number(tecnico),
        inicial,
        final
      })
      next()
    },
    meta: {
      title: 'Relatório de clientes atendidos (balancete requerido)',
      isIndustry: false,
      isShowSumValue: true,
      sumValueType: 'atendimentos',
      showSumValue: array =>
        array.reduce(
          (acum, item) => (acum += Number(item.visita_proporcao)),
          0
        ),
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/tecnico/filtros/atendidos'
      )
    }
  },
  {
    path: '/relatorios/tecnico/cliente/atendido/balancete-requerido/exibir',
    name: 'relatorios-tecnico-cliente-atendido-balancete-nao-requerido-show',
    beforeEnter: async (to, from, next) => {
      const { tecnico, inicial, final } = store.getters.variaveis
      await store.dispatch('getTecnico', {
        id: Number(tecnico)
      })
      await store.dispatch('getRelatorioTecnicoClienteAtendidoBalanceteNaoRequerido', {
        tecnico: Number(tecnico),
        inicial,
        final
      })
      next()
    },
    meta: {
      title: 'Relatório de clientes atendidos (balancete não requerido)',
      isIndustry: false,
      isShowSumValue: true,
      sumValueType: 'atendimentos',
      showSumValue: array =>
        array.reduce(
          (acum, item) => (acum += Number(item.visita_proporcao)),
          0
        ),
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/tecnico/filtros/atendidos'
      )
    }
  }
]
